// extracted by mini-css-extract-plugin
export default {"wrapper":"CommunicationLog_wrapper__uFE50","action-button":"CommunicationLog_action-button__9ZDZj"};